import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LOCKED_PATTERN_MEMBER_CTA } from "../../constants/patternTease.js";
import { startCheckout } from "../../utils/startCheckout.js";

const LockedPatternTease = ({ tease, verifiedEmail }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  if (!tease?.message) return null;

  const handleBecomeMember = async () => {
    if (!verifiedEmail) return;
    setIsLoading(true);
    setError("");
    try {
      await startCheckout(verifiedEmail);
    } catch (err) {
      console.error(err);
      setError("Unable to start checkout right now.");
      setIsLoading(false);
    }
  };

  return (
    <section className="locked-pattern-tease paywall-card" aria-labelledby="locked-pattern-tease-title">
      <h2 id="locked-pattern-tease-title" className="locked-pattern-tease__title">
        Your patterns are ready
      </h2>
      <p className="locked-pattern-tease__message" role="status">
        {tease.message}
      </p>
      <div className="locked-pattern-tease__actions">
        <button
          type="button"
          className="primary-button locked-pattern-tease__cta"
          onClick={handleBecomeMember}
          disabled={isLoading || !verifiedEmail}
        >
          {isLoading ? "Loading…" : LOCKED_PATTERN_MEMBER_CTA}
        </button>
        <Link to="/pricing" className="locked-pattern-tease__pricing-link">
          Compare plans
        </Link>
      </div>
      {error ? <p className="locked-pattern-tease__error">{error}</p> : null}
    </section>
  );
};

export default LockedPatternTease;
